<template>
    <main>
        <section class="intro">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <img class="title mb-xs-20 mb-md-40" :src="require('../assets/img/intro-title-'+currentLanguage+'.png')" alt="">
                        <p class="t-gotcha p-title">{{ $t('home.intro.subtitle') }}</p>
                        <p v-html="$t('home.intro.description')"></p>
                    </div>
                    <div class="intro__header d-none d-md-block col-sm-6">
                        <img src="../assets/img/header.png">
                    </div>
                </div>
            </div>
        </section>

        <section class="challenges">
            <div class="container">
                <h2 class="t-center">{{ $t('home.challenge.title') }}:</h2>
                <div class="row d-none d-lg-flex">
                    <div class="col-lg-10 offset-lg-1">
                        <div class="row">
                            <div class="col-sm-6 mb-xs-30" v-for="(challenge, index) in 5" :key="index">
                                <div class="challenge">
                                    <img :src="require('../assets/img/challenge-'+(index+1)+'-'+currentLanguage+'.png')">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-xs-30">
                                <div class="challenge --counter">
                                    <div class="challenge__content">
                                        <div class="challenge__content__count">
                                            <img class="mr-xs-5" :class="{'animated bounceIn': checkCountUpdated()}" src="../assets/img/count-icon.png" style="width:25px;">
                                            <span>{{ $t('home.challenge.counter.kiwilovers', { count: count }) }}</span>
                                        </div>
                                        <h3>{{ $t('home.challenge.counter.title') }}</h3>
                                        <div class="btn btn--counter" :class="{'--updated': checkCountUpdated()}" v-on:click="updateCount()">{{ checkCountUpdated() ? $t('home.challenge.counter.ctaUpdated') : $t('home.challenge.counter.cta') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-lg-none" v-swiper:challengeSwiper="challengeSwiperOptions">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(challenge, index) in 5" :key="index">
                        <img :src="require('../assets/img/challenge-'+(index+1)+'-'+currentLanguage+'.png')">
                    </div>
                    <div class="swiper-slide">
                        <div class="challenge --counter">
                            <div class="challenge__content">
                                <div class="challenge__content__count">
                                    <img class="mr-xs-5" :class="{'animated bounceIn': checkCountUpdated()}" src="../assets/img/count-icon.png" style="width:25px;">
                                    <span>{{ $t('home.challenge.counter.kiwilovers', { count: count }) }}</span>
                                </div>
                                <h3>{{ $t('home.challenge.counter.title') }}</h3>
                                <div class="btn btn--counter" :class="{'--updated': checkCountUpdated()}" v-on:click="updateCount()">{{ checkCountUpdated() ? $t('home.challenge.counter.ctaUpdated') : $t('home.challenge.counter.cta') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="experts pt-xs-60 pb-xs-60 pb-md-0">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 offset-lg-1">
                        <h2 class="t-center">{{ $t('home.experts.title') }}</h2>
                        <div v-swiper:expertSwiper="expertSwiperOptions">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide-1">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="expert__info quote">{{ $t('home.experts.celien.description') }}</p>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="expert">
                                                <img class="expert__picture" src="../assets/img/celien-rombouts.png">
                                                <img class="expert__dots" src="../assets/img/dots-2.png">
                                                <ul class="expert__title">
                                                    <li>Celien Rombouts</li>
                                                    <li>Healthy Habits</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide slide-2">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="expert__info quote">{{ $t('home.experts.marie.description') }}</p>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="expert">
                                                <img class="expert__picture" src="../assets/img/marie-de-burbure.png">
                                                <img class="expert__dots" src="../assets/img/dots-3.png">
                                                <ul class="expert__title">
                                                    <li>Marie de Burbure</li>
                                                    <li>MuseOfGreens</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-paginatio" slot="pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-navigation">
                <div class="swiper-navigation-button swiper-navigation-button--prev" v-on:click="expertSwiper.slidePrev()"></div>
                <div class="swiper-navigation-button swiper-navigation-button--next" v-on:click="expertSwiper.slideNext()"></div>
            </div>
        </section>

        <section class="tips-heading" v-animate-onscroll="'animated fadeInUp'">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <h2 class="t-center">{{ $t('home.tips.title') }}</h2>
                        <p class="t-center">{{ $t('home.tips.description') }}</p>
                        <ul class="tips-heading__nav">
                            <li v-scroll-to="'.tips-sport'">{{ $t('home.tips.sport.title') }}</li>
                            <li v-scroll-to="'.tips-mind'">{{ $t('home.tips.mind.title') }}</li>
                            <li v-scroll-to="'.tips-food'">{{ $t('home.tips.food.title') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section id="sport" class="tips-sport pt-xs-80 mb-xs-50 mb-sm-80" v-animate-onscroll="'animated fadeInUp'">
            <div class="container">
                <div class="row mb-xs-30 mb-sm-30 mb-md-40 mb-lg-80">
                    <div class="col-md-5 col-lg-4 offset-lg-1 pt-xs-0 pt-md-10 pt-lg-80 mobile-center">
                        <h2 class="tips-sport__title dots mb-xs-15">{{ $t('home.tips.sport.title') }}</h2>
                        <h3 class="tips-sport__subtitle mb-xs-15">{{ $t('home.tips.sport.subtitle') }}</h3>
                        <p>{{ $t('home.tips.sport.description') }}</p>
                    </div>
                    <div class="col-md-7">
                        <img class="tips-sport__video" src="../assets/img/sport-video-thumb.png" v-on:click="selectedVideo=$t('home.experts.marie.url');videoModal.showModal()">
                    </div>
                </div>
                <div class="row mr-xs-0 mr-lg-60">
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.sport.kiwi')}">
                                <img src="../assets/img/articles/thumb-1.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.sportKiwi.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.sport.apps')}">
                                <img src="../assets/img/articles/thumb-2.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.sportApps.cleanTitle') }}</div>
                                    <div>> {{ $t('common.vingers') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mt-xs-20 mt-md-0">
                        <div class="cta-block">
                            <img class="d-none d-md-block" :src="require('../assets/img/cta-sport-'+currentLanguage+'.png')">
                            <img class="d-md-none" :src="require('../assets/img/cta-sport-mob-'+currentLanguage+'.png')">
                            <a :href="$t('home.tips.sport.downloadUrl')" target="_blank" class="cta-block__btn">{{ $t('home.tips.sport.download') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="mind" class="tips-mind pt-xs-80 pb-xs-50 pb-md-80" v-animate-onscroll="'animated fadeInUp'">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-lg-4 offset-lg-1 pt-xs-0 pt-sm-80 mobile-center">
                        <h2 class="tips-mind__title dots mb-xs-15">{{ $t('home.tips.mind.title') }}</h2>
                        <h3 class="tips-mind__subtitle mb-xs-15">{{ $t('home.tips.mind.subtitle') }}</h3>
                        <p>{{ $t('home.tips.mind.description') }}</p>
                    </div>
                    <div class="col-md-7 d-none d-md-block">
                        <div class="tips-mind__header">
                            <img :src="require('../assets/img/mind-header-'+currentLanguage+'.png')">
                        </div>
                    </div>
                </div>
                <div class="row mr-xs-0 mr-lg-60">
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.humeur')}">
                                <img src="../assets/img/articles/thumb-3.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindHumeur.cleanTitle') }}</div>
                                    <div>> 1,2,3… happy!</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.lachen')}">
                                <img src="../assets/img/articles/thumb-4.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindLachen.cleanTitle') }}</div>
                                    <div>> Smile!</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mt-xs-20 mt-md-0">
                        <div class="cta-block">
                            <img class="d-none d-md-block" :src="require('../assets/img/cta-mind-'+currentLanguage+'.png')">
                            <img class="d-md-none" :src="require('../assets/img/cta-mind-mob-'+currentLanguage+'.png')">
                            <a :href="$t('home.tips.mind.downloadUrl')" target="_blank" class="cta-block__btn">{{ $t('home.tips.mind.download') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="food" class="tips-food pt-xs-80 mb-xs-50 mb-sm-80" v-animate-onscroll="'animated fadeInUp'">
            <div class="container">
                <div class="row mb-xs-30 mb-sm-30 mb-md-40 mb-lg-80">
                    <div class="col-md-5 col-lg-4 offset-lg-1 pt-xs-0 pt-md-10 pt-lg-80 mobile-center">
                        <h2 class="tips-food__title dots mb-xs-15">{{ $t('home.tips.food.title') }}</h2>
                        <h3 class="tips-food__subtitle mb-xs-15">{{ $t('home.tips.food.subtitle') }}</h3>
                        <p>{{ $t('home.tips.food.description') }}</p>
                    </div>
                    <div class="col-md-7">
                        <img class="tips-food__video" src="../assets/img/food-video-thumb.png" v-on:click="selectedVideo=$t('home.experts.celien.url');videoModal.showModal()">
                    </div>
                </div>
                <div class="row mr-xs-0 mr-lg-60">
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.food.ontbijt')}">
                                <img src="../assets/img/articles/thumb-5.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.foodOntbijt.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.food.fruit')}">
                                <img src="../assets/img/articles/thumb-6.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.foodFruit.cleanTitle') }}</div>
                                    <div>> {{ $t('common.lees') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mt-xs-20 mt-md-0">
                        <div class="cta-block">
                            <img class="d-none d-md-block" :src="require('../assets/img/cta-food-'+currentLanguage+'.png')">
                            <img class="d-md-none" :src="require('../assets/img/cta-food-mob-'+currentLanguage+'.png')">
                            <a :href="$t('home.tips.food.downloadUrl')" target="_blank" class="cta-block__btn">{{ $t('home.tips.food.download') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="videos" class="videos pt-xs-60 pb-xs-20 pb-lg-100">
            <div class="container">
                <h3 class="text-center mb-xs-40">{{ $t('home.videos.title') }}</h3>
            </div>
            <div v-animate-onscroll="'animated fadeInRight'" v-swiper:videoSwiper="videoSwiperOptions">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(video, index) in youtubeVideos" :key="index">
                        <div class="video" v-on:click="youtubeModal.showModal();youtubeSelectedIndex=index;">
                            <img class="video__thumb" :src="require('../assets/img/videos/video-thumb-'+(index+1)+'-'+currentLanguage+'.png')" alt="">
                            <div class="video__title">{{ video.title[currentLanguage] }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-navigation">
                <div class="swiper-navigation-button swiper-navigation-button--prev" v-on:click="videoSwiper.slidePrev()"></div>
                <div class="swiper-navigation-button swiper-navigation-button--next" v-on:click="videoSwiper.slideNext()"></div>
            </div>
        </section>

        <Modal ref="videoModal">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="selectedVideo"></iframe>
            </div>
        </Modal>

        <Modal ref="youtubeModal">
            <template>
                <div class="embed-responsive embed-responsive-16by9 mb-xs-20">
                    <iframe class="embed-responsive-item" :src="youtubeVideos[youtubeSelectedIndex].url[currentLanguage]+'?autoplay=1'"></iframe>
                </div>
                <div class="youtube-swiper" v-swiper:ytSwiper="ytSwiperOptions" @ready="ytSwiper.slideTo(youtubeSelectedIndex)">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(video, index) in 10" :key="index">
                            <div class="video" :class="{'--active': youtubeSelectedIndex === index}" v-on:click="youtubeSelectedIndex=index">
                                <img class="video__thumb" :src="require('../assets/img/videos/video-thumb-'+(index+1)+'-'+currentLanguage+'.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>
    </main>
</template>

<script>
import { Trans } from '@/plugins/Translation';
import Modal from '@/components/shared/Modal';

export default {
    name: "home",
    components: { Modal },
    data() {
        return {
            count: 0,
            youtubeSelectedIndex: 0,
            selectedVideo: '',
            expertSwiperOptions: {
                loop: true,
                direction: 'horizontal',
                slidesPerView: 1
            },
            challengeSwiperOptions: {
                loop: false,
                direction: 'horizontal',
                spaceBetween: 15,
                breakpoints: {
                    320: {
                    slidesPerView: 1.1
                    },
                    450: {
                    slidesPerView: 1.2
                    },
                    600: {
                    slidesPerView: 1.6
                    },
                    768: {
                    slidesPerView: 2.1
                    }
                }
            },
            videoSwiperOptions: {
                loop: false,
                direction: 'horizontal',
                spaceBetween: 15,
                breakpoints: {
                    320: {
                    slidesPerView: 1.2
                    },
                    640: {
                    slidesPerView: 2.4
                    },
                    992: {
                    slidesPerView: 3.6
                    }
                }
            },
            ytSwiperOptions: {
                loop: false,
                direction: 'horizontal',
                spaceBetween: 15,
                slideToClickedSlide: true,
                breakpoints: {
                    320: {
                    slidesPerView: 2.4
                    },
                    640: {
                    slidesPerView: 2.4
                    },
                    992: {
                    slidesPerView: 3.6
                    }
                }
            },
            youtubeVideos: [
                {
                    title: {
                        "nl": "Huisgemaakte confituur van Zespri kiwi's",
                        "fr": "Confiture maison de kiwis Zespri"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/AT8_CO46FRo",
                        "fr": "https://www.youtube.com/embed/L7aZOzAwsSY"
                    }
                },
                {
                    title: {
                        "nl": "Pannenkoekjes met Zespri kiwi & havermout",
                        "fr": "Crêpes d’avoine au kiwi Zespri"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/AB9xzL3meBQ",
                        "fr": "https://www.youtube.com/embed/PWOdtSpIx3o"
                    }
                },
                {
                    title: {
                        "nl": "Ontbijtpizza met Zespri kiwi & bessen",
                        "fr": "Pizza du petit-déjeuner au kiwi Zespri & fruits des bois"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/uiajYpThULc",
                        "fr": "https://www.youtube.com/embed/FxNVTeDnU3s"
                    }
                },
                {
                    title: {
                        "nl": "Smoothie van Zespri Green kiwi, chiazaden en sojamelk",
                        "fr": "Smoothie de kiwi Zespri green, graines de chia et lait de soja"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/-h7SoFdg59A",
                        "fr": "https://www.youtube.com/embed/Pdfo-n2GQIU"
                    }
                },
                {
                    title: {
                        "nl": "Havermoutrepen met Zespri kiwi en walnoten",
                        "fr": "Barres d'avoine au kiwi Zespri et aux noix"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/HnuKq0xbwTw",
                        "fr": "https://www.youtube.com/embed/-bcfjQ2GxiI"
                    }
                },
                {
                    title: {
                        "nl": "Ontbijtgranola met Zespri Green kiwi's",
                        "fr": "Granola au kiwi Zespri Green"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/O9rRPeJtDvM",
                        "fr": "https://www.youtube.com/embed/W9a51qob-Ek"
                    }
                },
                {
                    title: {
                        "nl": "Smoothie van Zespri Green kiwi, aardbeien en amandelmelk",
                        "fr": "Smoothie au kiwi Zespri Green, fraises et lait d'amande"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/56Rl49CBrwA",
                        "fr": "https://www.youtube.com/embed/ZGPVIOzHfDE"
                    }
                },
                {
                    title: {
                        "nl": "Superkoekjes met Zespri kiwi, chiazaad en haver",
                        "fr": "Super-biscuits au kiwi Zespri, graines de chia et avoine"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/Uv0MvHEEArY",
                        "fr": "https://www.youtube.com/embed/Ohi3yKf5bN8"
                    }
                },
                {
                    title: {
                        "nl": "Havermoutontbijt met Zespri kiwi en wortel",
                        "fr": "Bols de flocons d’avoine aux kiwis Zespri et aux carottes"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/ITFYPeRP5oo",
                        "fr": "https://www.youtube.com/embed/QuSBVisOZQE"
                    }
                },
                {
                    title: {
                        "nl": "Ontbijtburrito met Zespri kiwi, banaan en pindakaas",
                        "fr": "Burrito au kiwi Zespri, à la banane et au beurre de cacahuètes"
                    },
                    url: {
                        "nl": "https://www.youtube.com/embed/aKMNB8bbo7c",
                        "fr": "https://www.youtube.com/embed/DlJn1VpKRzA"
                    }
                }
            ]
        }
    },
    computed: {
        videoModal() {
            return this.$refs.videoModal;
        },
        youtubeModal() {
            return this.$refs.youtubeModal;
        },
        currentLanguage () {
            return Trans.currentLanguage
        }
    },
    mounted() {
        this.getCount();

        this.$nextTick(function () {
            const hash = this.$route.hash;
            if(hash.length > 0){
                setTimeout(() => {
                    this.$scrollTo(hash);
                }, 1000);
            }
        });
    },
    methods: {
        getCount() {
            this.axios.get('https://zespri.headoffice.be/api/current_count').then((response) => {
                this.count = response.data.count;
            });
        },
        updateCount() {
            if(!this.checkCountUpdated()){
                this.axios.post('https://zespri.headoffice.be/api/register_click').then((response) => {
                    this.count = response.data.count;
                    this.setCountUpdate();
                });
            }
        },
        checkCountUpdated(){
            return localStorage.getItem('countUpdated');
        },
        setCountUpdate(){
            localStorage.setItem('countUpdated', this.count);
        }
    }
};
</script>
